import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, Space, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import DataTable from '../components/DataTable';
import RiskBadge from '../components/RiskBadge';
import ScoreBadge from '../components/ScoreBadge';
import AiAnalysisBadge from '../components/AiAnalysisBadge';
import { reviewsApi } from '../api/reviews.api';
import type { ReviewQueueItem } from '../types/reviews';

export default function ReviewQueue() {
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ['review-queue'], queryFn: reviewsApi.queue });

  const columns: ColumnsType<ReviewQueueItem> = [
    { title: 'زمان', dataIndex: 'timestamp', key: 'timestamp', width: 160, render: (v: string) => dayjs(v).format('YYYY-MM-DD HH:mm') },
    { title: 'شناسه تماس', dataIndex: 'externalCallId', key: 'externalCallId' },
    { title: 'اپراتور', dataIndex: 'operatorName', key: 'operatorName' },
    { title: <Space size={4}>ریسک <AiAnalysisBadge compact /></Space>, key: 'risk', render: (_, r) => <RiskBadge level={r.riskLevel} /> },
    {
      title: <Space size={4}>احتمال شکایت <AiAnalysisBadge compact /></Space>,
      key: 'complaint',
      render: (_, r) => (r.complaintLikelihood == null ? '—' : `${Math.round(r.complaintLikelihood * 100)}%`),
    },
    { title: <Space size={4}>امتیاز کیفیت <AiAnalysisBadge compact /></Space>, key: 'score', render: (_, r) => <ScoreBadge score={r.overallQualityScore} /> },
  ];

  return (
    <Card title={<Typography.Title level={4} style={{ margin: 0 }}>صف بازبینی</Typography.Title>}>
      <DataTable<ReviewQueueItem>
        rowKey="callId"
        columns={columns}
        dataSource={q.data ?? []}
        loading={q.isLoading}
        onRow={(r) => ({ onClick: () => navigate(`/calls/${r.callId}`), style: { cursor: 'pointer' } })}
      />
    </Card>
  );
}
